import React ,{useEffect, useState} from 'react'
import { GetElearningData } from './API';
import WeekList from './WeekList';

export default function Index(props) {
    const [data, setData] = useState([])
    useEffect(() => {
        GetElearningData(props.match.params.crsnum).then(data => {
            console.log(data)
            setData(data);
        })
    }, [props.match.params.crsnum])
    return (
        <div>
            <WeekList data={data}/>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/pages/course/E-Learning/Index.js